// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E-G3F","content":"styles_content__28MuS"};